import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export default () => {
  const { t, i18n } = useTranslation('labels');

  const options = useMemo(
    () => [
      {
        id: 0,
        name: t('book_a_followup_appointment'),
        info: t('set_up_a_followup_with_your_provider_based_on_your_previous_services'),
      },
      {
        id: 4,
        name: t('request_a_new_service'),
        info: t('request_an_appointment_from_a_list_of_all_available_services_by_filling_out_a_new_intake'),
      },
    ],
    [i18n.language],
  );

  return { data: options };
};
